import React, { useContext } from 'react';
import { Table } from 'semantic-ui-react';
import AssetStore from '../../../app/stores/assetStore';


const KeeperForm = () => {
  const assetStore = useContext(AssetStore);
  const {
    asset
  } = assetStore;

  return (
    <div>
      <Table celled >
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell>Keeper</Table.HeaderCell>
        <Table.HeaderCell>Keep Date</Table.HeaderCell>
      </Table.Row>
    </Table.Header>

    <Table.Body>
    {asset!.keep.map(keep => (
      
      <Table.Row key={keep.id}>
        <Table.Cell >{keep.keeper}</Table.Cell>
        <Table.Cell >{keep.keepDate.substr(8,2) + '/' +
               keep.keepDate.substr(5,2) + '/' + keep.keepDate.substr(0,4)}</Table.Cell>
      </Table.Row>
    ))}
    </Table.Body>
  </Table>
    </div>
  );
};

export default KeeperForm;
